export default {
  "init":"測試",
  "ogTitle":"Celebrate our 15th Anniversary over the Castle of Magical Dreams\nExplore the Castle of Magical Dreams, embark on your virtual journey now.",
  "ogSite_name":"Celebrate our 15th Anniversary over the Castle of Magical Dreams",
  "ogDescription":"ENG 率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  "siteDescription":"ENG 率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  "quote":"ENG 率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  // "homeURL":"https://hkdl-h5-uat.digitalcampaignasia.com/phase3/campaigns/castleofmagicaldreams/index.html#/",
  "homeURL":"https://www.hongkongdisneyland.com/campaigns/castleofmagicaldreams/index.html",
  "ticketingURL":"https://www.hongkongdisneyland.com/offers-discounts/celebrate-together-group-ticket-offer/?CMP=TixOfrCpn15An21Hkh5CeleToGpTixOfr",
  "exhibitionURL":"https://www.hongkongdisneyland.com/building-a-dream/?CMP=Cpn15An20Hkh5buildadm",
}



// WEBPACK FOOTER //
// ./src/language/en.js